const config = {
  development: {
    app_env: 'development',
    app_url: 'http://localhost:9005',
    api_url: 'http://localhost:3000',
    modfile_url: 'http://localhost:3002/',
    doconvert_url: 'http://localhost:3003/',
    provider_url: 'http://localhost:3004/',
    domain_url: 'localhost',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ],
    unified: {
      api_url: 'https://api.unified.to',
      env: 'William',
      workspace_id: '695bf267e34c00dfe4bc16ae'
    },
    daily: {
      domain: 'quickin-development.daily.co'
    },
    meta: {
      graph_version: 'v25.0',
      app_id: '27091796117183140',
      whatsapp_config_id: '1674159931088096',
      is_sandbox: true
    }
  },
  testing: {
    app_env: 'testing',
    app_url: 'https://app.testing.quickin.net/',
    api_url: 'https://api.testing.quickin.net/',
    modfile_url: 'https://modfile.testing.quickin.net/',
    doconvert_url: 'https://doconvert.testing.quickin.net/',
    provider_url: 'https://provider.testing.quickin.net/',
    domain_url: 'testing.quickin.net',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ],
    unified: {
      api_url: 'https://api.unified.to',
      env: 'William',
      workspace_id: '695bf267e34c00dfe4bc16ae'
    },
    daily: {
      domain: 'quickin-testing.daily.co'
    },
    meta: {
      graph_version: 'v25.0',
      app_id: '790029717464619',
      whatsapp_config_id: '1099169519545516',
      is_sandbox: true
    }
  },
  staging: {
    app_env: 'staging',
    app_url: 'https://app.staging.quickin.net/',
    api_url: 'https://api.staging.quickin.net/',
    modfile_url: 'https://modfile.staging.quickin.net/',
    doconvert_url: 'https://doconvert.staging.quickin.net/',
    provider_url: 'https://provider.staging.quickin.net/',
    domain_url: 'staging.quickin.net',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ],
    unified: {
      api_url: 'https://api.unified.to',
      env: 'William',
      workspace_id: '695bf267e34c00dfe4bc16ae'
    },
    daily: {
      domain: 'quickin-staging.daily.co'
    },
    meta: {
      graph_version: 'v25.0',
      app_id: '1861504308562366',
      whatsapp_config_id: '1099169519545516',
      is_sandbox: true
    }
  },
  production: {
    app_env: 'production',
    app_url: 'https://app.quickin.io/',
    api_url: 'https://api.quickin.io/',
    modfile_url: 'https://modfile.quickin.io/',
    doconvert_url: 'https://doconvert.quickin.io/',
    provider_url: 'https://provider.quickin.io/',
    domain_url: 'quickin.io',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ],
    unified: {
      api_url: 'https://api.unified.to',
      env: 'Production',
      workspace_id: '695bf267e34c00dfe4bc16ae'
    },
    daily: {
      domain: 'quickin.daily.co'
    },
    meta: {
      graph_version: 'v25.0',
      app_id: '1392831039408456',
      whatsapp_config_id: '1796451118165788',
      is_sandbox: false
    }
  }
}

console.log('Env: ' + process.env.NODE_ENV)
module.exports = config[process.env.NODE_ENV || 'development']



// WEBPACK FOOTER //
// ./src/config.js